<template>
  <header id="page-header">
    <b-navbar toggleable type="inverse fixed-top">

      <b-nav-toggle target="nav_collapse"></b-nav-toggle>

      <b-link class="navbar-brand">
        <h1 class="navbar-brand"><span class="oldtimers-logo">Oldtimers</span> Garage</h1>
      </b-link>

      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav>
          <b-nav-item><router-link to="/">{{ $t('message.title.main.home') }}</router-link></b-nav-item>
        </b-navbar-nav>

        <b-navbar-nav class="ml-auto">
          <b-nav-item><a href="#" @click.prevent="updateLang('cs')"><img src="../../assets/img/flag/flag-cs.png" alt="cs" title="Czech"></a></b-nav-item>
          <b-nav-item><a href="#" @click.prevent="updateLang('en')"><img src="../../assets/img/flag/flag-en.png" alt="en" title="English"></a></b-nav-item>
        </b-navbar-nav>

        <b-nav is-nav-bar class="ml-auto navbar-right">
          <b-nav-item href="#"><router-link to="/cars">{{ $t('message.title.site.our_cars') }}</router-link></b-nav-item>
        </b-nav>

      </b-collapse>
    </b-navbar>
  </header>
</template>

<script>
  import Vue from 'vue'
  import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.esm'
  import VueScrollTo from 'vue-scrollto/vue-scrollto'

  Vue.use(BootstrapVue)
  Vue.use(VueScrollTo)

  export default {
    components: {
      BootstrapVue, VueScrollTo
    },
    methods: {
      updateLang(lang) {
        Vue.i18n.set(lang)
      }
    }
  }
</script>

<style>
  li.nav-item a {
    color: #fff;
    font-weight: bold;
  }
  li.nav-item a:hover {
    color: #000;
  }
</style>



// WEBPACK FOOTER //
// Header.vue?4c952c27